import loadable from '@loadable/component';

export const CardGallerySliderLoadable = loadable(() => import('./CardGallerySlider'), { ssr: false });

CardGallerySliderLoadable.displayName = 'Loadable[CardGallerySlider]';
